/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': '清除選取內容',
  'paginated-picker.async-select.menu-list.error-message.error-message': '無法擷取資料',
  'paginated-picker.async-select.menu-list.error-message.retry-message': '按一下以重試',
  'paginated-picker.async-select.menu-list.loading-message.loading-message': '正在載入...',
  'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': '顯示較多',
  'paginated-picker.async-select.pagination-details.of-total-count': '第 {itemsCount} 個，共 {totalCount} 個',
  'paginated-picker.async-select.select.no-options-message.no-options-message': '找不到相符項目',
  'paginated-picker.async-select.select.option.error-message': '無法擷取資料',
  'paginated-picker.async-select.select.option.retry-message': '按一下以重試',
  'paginated-picker.async-select.select.search-placeholder': '搜尋',
  'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': '顯示完整清單'
};